import actions from "./drip-campaign-actions";
import getters from "./drip-campaign-getters";
import mutations from "./drip-campaign-mutations";
import state from "./drip-campaign-state";
const dripCampaignStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default dripCampaignStore;